(() => {
  const initReadMore = (root) => {
    root.querySelectorAll('[data-team-read-more]').forEach((wrap) => {
      if (wrap.dataset.initialised === 'true') return;
      wrap.dataset.initialised = 'true';

      const trigger = wrap.querySelector('[data-team-read-more-trigger]');
      const template = wrap.querySelector('[data-team-read-more-template]');
      if (!trigger || !template) return;

      const panelId = trigger.getAttribute('aria-controls');
      if (!panelId) return;

      trigger.addEventListener('click', () => {
        let panel = wrap.querySelector('[data-team-read-more-panel]');
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'team-grid__bio-body rte';
          panel.id = panelId;
          panel.dataset.teamReadMorePanel = '';
          panel.hidden = true;
          wrap.appendChild(panel);
        }

        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (!expanded && !panel.dataset.loaded) {
          panel.innerHTML = template.innerHTML;
          panel.dataset.loaded = 'true';
        }

        const next = !expanded;
        trigger.setAttribute('aria-expanded', String(next));
        panel.hidden = !next;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReadMore(document));
  } else {
    initReadMore(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initReadMore(event.target);
  });
})();
